<template>
  <div class="map-cushman-container pb-4">
    <h4 class="font-PB text-dark text-uppercase text-center mb-3 mt-5 cushman-title">Mercado de inmuebles logísticos
    </h4>
    <div class="col-8 col-sm-12 col-md-7 mx-auto">
      <p class="font-PM text-center subhead">Al análisis tradicional que divide el mercado por zona, se agrega la
        división por zonas, que complementa y mejora las estrategias de ubicación de los inmuebles logísticos</p>
    </div>
    <div class="button-container large d-flex justify-content-center mt-4 mb-2">
      <div
        class="ratio-btn-container-mobile d-flex d-md-none flex-column mb-3 justify-content-center align-items-center">
        <button class="text-uppercase mb-2 text-center btn font-ARB" :class="{ active: state.selectedMap === 'all' }"
          @click="e => handleChangeMap('all')">
          Todas las zonas
        </button>
        <div class="d-flex">
          <button class="text-uppercase mr-3 text-center btn font-ARB"
            :class="{ active: state.selectedMap === 'radio2' }" @click="e => handleChangeMap('radio2')">
            1
          </button>
          <button class="text-uppercase mr-3 text-center btn font-ARB"
            :class="{ active: state.selectedMap === 'radio3' }" @click="e => handleChangeMap('radio3')">
            2
          </button>
          <button class="text-uppercase text-center btn font-ARB" :class="{ active: state.selectedMap === 'radio4' }"
            @click="e => handleChangeMap('radio4')">
            3
          </button>
        </div>
      </div>
    </div>
    <div class="w-100 map-cushman d-flex mt-2 mb-4">
      <div class="col-lg-6 map-container">
        <picture :class="{ active: state.selectedMap === 'all' }">
          <source media="(max-width: 575px)" srcset="/images/indices/radio-all-desktop-new.svg">
          <source media="(min-width: 576px)" srcset="/images/indices/radio-all-desktop-new.svg">
          <img class="map" src="/images/indices/radio-all-desktop-new.svg"
            alt="Mapa mostrando los 4 radios y sus límites">
        </picture>
        <picture :class="{ active: state.selectedMap === 'radio2' }">
          <source media="(max-width: 575px)" srcset="/images/indices/IND_1_zona-norte.svg">
          <source media="(min-width: 576px)" srcset="/images/indices/IND_1_zona-norte.svg">
          <img class="map" src="/images/indices/IND_1_zona-norte.svg" alt="Mapa mostrando el radio dos y sus límites">
        </picture>
        <picture :class="{ active: state.selectedMap === 'radio3' }">
          <source media="(max-width: 575px)" srcset="/images/indices/IND_2_zona-oeste.svg">
          <source media="(min-width: 576px)" srcset="/images/indices/IND_2_zona-oeste.svg">
          <img class="map" src="/images/indices/IND_2_zona-oeste.svg" alt="Mapa mostrando el radio tres y sus límites">
        </picture>
        <picture :class="{ active: state.selectedMap === 'radio4' }">
          <source media="(max-width: 575px)" srcset="/images/indices/IND_3_zona-sur.svg">
          <source media="(min-width: 576px)" srcset="/images/indices/IND_3_zona-sur.svg">
          <img class="map" src="/images/indices/IND_3_zona-sur.svg" alt="Mapa mostrando el radio cuatro y sus límites">
        </picture>
        <picture :class="{ active: state.selectedMap === 'zones' }">
          <source media="(max-width: 575px)" srcset="/images/indices/IND_1_zona-norte.svg">
          <source media="(min-width: 576px)" srcset="/images/indices/IND_1_zona-norte.svg">
          <img class="map map-zones" src="IND_1_zona-norte.svg"
            alt="Mapa mostrando las zonas norte, oeste y sur y sus límites">
        </picture>
      </div>
      <div class="col-lg-6">
        <div class="tab-container">
          <div v-if="state.selectedTab === 'radios'" class="ratio-container">
            <div class="ratio-btn-container d-none d-md-flex">
              <button class="text-uppercase mr-3 text-center btn font-ARB"
                :class="{ active: state.selectedMap === 'all' }" @click="e => handleChangeMap('all')">
                Todas las zonas
              </button>
              <div>
                <button class="text-uppercase mr-3 text-center btn font-ARB"
                  :class="{ active: state.selectedMap === 'radio2' }" @click="e => handleChangeMap('radio2')">
                  1
                </button>
                <button class="text-uppercase mr-3 text-center btn font-ARB"
                  :class="{ active: state.selectedMap === 'radio3' }" @click="e => handleChangeMap('radio3')">
                  2
                </button>
                <button class="text-uppercase mr-3 text-center btn font-ARB"
                  :class="{ active: state.selectedMap === 'radio4' }" @click="e => handleChangeMap('radio4')">
                  3
                </button>
              </div>
            </div>
            <div class="data-container my-3">
              <h4 class="text-uppercase font-PM" v-if="state.selectedMap === 'all'">
                <span class="font-PB">{{ radios[state.selectedMap].name }}</span>
              </h4>
              <h4 class="text-uppercase font-PM" v-else>
                <span class="font-PB">{{ radios[state.selectedMap].name }} </span>
              </h4>
              <div class="row">
                <div class="col">
                  <h3 class="text-uppercase font-PM mb-0 mt-2 no-wrap">USD <span class="font-PB">{{
                    radios[state.selectedMap].alquiler }}</span></h3>
                  <p class="font-PM p-sm">ALQUILER PEDIDO <br>(USD/M2/MES)</p>
                </div>
                <div class="col">
                  <h3 class="text-uppercase font-PB mb-0 mt-2">{{ radios[state.selectedMap].vacancia }}<span
                      class="font-PM">%</span></h3>
                  <p class="font-PM p-sm">VACANCIA (%)</p>
                </div>
              </div>
              <div class="refresh">
                <span class="font-PM">DATOS ACTUALIZADOS AL Primer trimestre de 2025</span>
              </div>
            </div>
          </div>
          <div v-else class="zones-container">
            <div class="data-container">
              <h4 class="text-uppercase font-PB">Total</h4>
              <p class="font-PB">Alquiler pedido (USD/M2/MES): {{ zonas.total.alquiler }}<br>Vacancia (%) {{
                zonas.total.vacancia }} </p>
              <div class="hr"></div>
              <h4 class="text-uppercase font-PB mt-4">Zona Norte</h4>
              <p class="font-PB">Alquiler pedido: {{ zonas.norte.alquiler }} | Vacancia: {{ zonas.norte.vacancia }}</p>
              <h4 class="text-uppercase font-PB mt-4">Zona Oeste</h4>
              <p class="font-PB">Alquiler pedido: {{ zonas.oeste.alquiler }} | Vacancia: {{ zonas.oeste.vacancia }}</p>
              <h4 class="text-uppercase font-PB mt-4">Zona Sur</h4>
              <p class="font-PB mb-3">Alquiler pedido: {{ zonas.sur.alquiler }} | Vacancia: {{ zonas.sur.vacancia }}</p>
              <div class="refresh mt-4">
                <span class="font-PM">DATOS ACTUALIZADOS AL Primer trimestre de 2025</span>
              </div>
            </div>
          </div>
          <div class="footer">
            <div class="d-flex align-items-center mt-2 anunciantes">
              <div class="img-container mr-2 mr-md-3">
                <img src="/images/anunciantes/Newmark-Logo-CMYK.png" alt="Cushman and Wakefield">
              </div>
              <div class="vr mr-2 mr-md-3"></div>
              <div class="font-MtB text-uppercase side-info">
                Sistema de Zonas
              </div>
            </div>
            <div class="d-flex flex-column h-100">
              <p class="font-PM mt-2 bottom-info">El análisis que mejora las decisiones logísticas.</p>
              <a href="https://nmrk.com.ar/" target="_blank"
                class="btn mt-4 ratio-link font-ARB text-center text-uppercase">Ver más datos por zona</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const mockupData = {
  zonas: {
    norte: {
      alquiler: 'USD 7,4',
      vacancia: '3,9%'
    },
    oeste: {
      alquiler: 'USD 6,9',
      vacancia: '1,9%'
    },
    sur: {
      alquiler: 'USD 5,7',
      vacancia: '2,9%'
    },
    total: {
      alquiler: 'USD 6,9',
      vacancia: '4,9%'
    },
  },
  radios: {
    radio2: {
      alquiler: '7,4',
      vacancia: '3,9',
      name: 'Zona 1 - norte',
      from: '15 Km'
    },
    radio3: {
      alquiler: '6,9',
      vacancia: '1,9',
      name: 'Zona 2 - oeste',
      from: '30 Km'
    },
    radio4: {
      alquiler: '5,7',
      vacancia: '2,9',
      name: 'Zona 3 - sur',
      from: '45 Km'
    },
    all: {
      alquiler: '6,9',
      vacancia: '4,9',
      name: 'Total',
      from: '45 Km'
    },
  }
}


export default {
  props: ['data'],
  methods: {
    handleChangeTab(tab) {
      if (tab !== this.selectedTab) {
        tab === 'radios'
          ? this.handleChangeMap('all')
          : this.handleChangeMap('zones')
      }
      this.state.selectedTab = tab;
    },
    handleChangeMap(map) {
      this.state.selectedMap = map;
    }
  },
  data() {
    return {
      zonas: mockupData.zonas,
      radios: mockupData.radios,
      state: {
        selectedTab: 'radios',
        selectedMap: 'all'
      }
    }
  }
}
</script>

<style lang="scss">
.map-cushman-container {
  .btn {
    border: 1px solid #0074C4;
    color: #0074C4;
    border-radius: 4px;
    font-size: 0.875rem;
    padding: 9px 17px;
    background-color: #ffffff;
    min-width: 17px;
    cursor: pointer;
    transition-property: background-color, color;
    transition-duration: .3s;
    transition-timing-function: ease;

    &.active {
      background-color: #0074C4;
      color: #ffffff;
    }
  }

  .map-button {
    all: unset;
    border: 1px solid #0074C4;
    color: #0074C4;
    border-radius: 4px;
    padding: 7px 15px;
    font-size: 0.875rem;
    background-color: #ffffff;
    cursor: pointer;
    transition-property: background-color, color;
    transition-duration: .3s;
    transition-timing-function: ease;

    &:first-child {
      padding-right: 100px;
      padding-left: 22px;
    }

    &:nth-child(2) {
      position: absolute;
      left: 102px;
    }

    &.active {
      background-color: #0074C4;
      color: #ffffff;
    }
  }

  .button-container.small {
    display: none;
  }

  .map-cushman {
    position: relative;

    @media screen and (min-width: 1133px) {
      &>div:nth-child(2) {
        flex: 1;
        max-width: initial;
      }
    }

    .button-container {
      position: relative;
    }

    .ratio-container {
      .ratio-btn-container {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        row-gap: 10px;

        &>div {
          display: flex;
        }
      }
    }

    .data-container {
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.125);
      width: 100%;
      padding: 20px 18px;

      h4 {
        font-size: 1rem;
      }

      h3 {
        color: #4A4A4A;
        font-size: 2rem;
      }

      p {
        font-size: 14px;
        color: #898989;
      }

      .hr {
        background-color: #646464;
        width: 100%;
        height: 1px;
      }

      @media screen and (max-width: 780px) {
        h3 {
          font-size: 28px;
        }
      }
    }

    .refresh {
      font-size: 10px;
      color: #969696;
    }

    .map-container {
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.125);
      position: relative;
      overflow: hidden;
      max-height: 560px;

      @media screen and (min-width: 1133px) {
        max-width: 510px;
      }

      picture {
        opacity: 0;
        visibility: hidden;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        z-index: 1;
        transition-property: opacity, visibility;
        transition-duration: 1.2s, 1.3s;
        transition-timing-function: ease;
        width: 100%;
        height: 100%;
      }

      picture.active {
        opacity: 1;
        visibility: visible;
        z-index: 2;
        transition-property: opacity, visibility;
        transition-duration: .8s, .85s;
        transition-timing-function: ease;
      }

      .map {
        width: 100%;
        height: 100%;
        object-fit: cover;

        &-zones {
          max-height: 570px;
          position: absolute;
          object-position: 60px;

          @media screen and (min-width: 1133px) {
            object-position: 0px;
          }
        }
      }
    }

    .zones-container {

      p,
      h4 {
        color: #040404;
      }
    }

    .footer {
      .vr {
        height: 40px;
        width: 1px;
        background-color: #CDCDCD;
      }

      .side-info {
        color: #707272;
        font-size: 1rem;
      }

      .ratio-link {
        width: fit-content;
      }

      .img-container {
        width: 25%;
        min-width: 150px;

        @media screen and (min-width: 991px) {
          width: 168px;
        }

        & img {
          width: 100%;
        }
      }

      .bottom-info {
        font-size: 14px;
        color: #4A4A4A;
      }

      @media screen and (max-width: 990px) {

        .side-info {
          font-size: 16px;
        }
      }
    }
  }
}

@media screen and (max-width: 780px) {
  .map-cushman-container {
    .map-cushman {
      margin-top: 100px;
      flex-direction: column;

      .map-container {
        height: 100vw;
      }

      .col-lg-6:nth-child(2) {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }

      .ratio-btn-container {
        justify-content: center;
      }
    }

    .btn {
      min-width: initial;
      font-size: 12px;
      margin-right: 5px !important;
    }

    .button-container {
      &.large {
        display: none;
      }

      &.small {
        display: block;
        margin-top: 24px;
        margin-bottom: 24px;
        position: relative;
        left: 50%;
        transform: translateX(-128px);
      }
    }

    .ratio-link {
      align-self: center;
    }
  }
}

@media screen and (max-width: 575px) {
  .map-cushman-container {

    .col-8 {
      max-width: 100%;
    }

    .subhead {
      margin: 0 auto;
    }

    .map-cushman .map-container .map-zones {
      object-position: 0px;
      object-fit: cover;
    }

    .img-container img {
      width: 156px;
    }

    .footer {
      p {
        font-size: 14px;
      }

      .side-info {
        font-size: 13px;
      }
    }
  }
}
</style>
